import Vue from 'vue';

import { MSEnum } from '@/common/enumeration';
import moment from 'moment';
import i18nEnum from '@/i18n/vi/i18nEnum';
let numeral = require('numeral');
let mo = moment;
mo.locale('vi');
numeral.register('locale', 'vi', {
	delimiters: {
		thousands: '.',
		decimal: ','
	},
	abbreviations: {
		thousand: 'nghìn',
		million: 'triệu',
		billion: 'tỷ',
		trillion: 'nghìn tỷ'
	},
	ordinal: function(number) {
		return '.';
	},
	currency: {
		symbol: '' //'₫'
	}
});

// switch between locales
numeral.locale('vi');
/**
 * Xử lý convert từ string sang DateTime
 * @param {String} sDate Chuỗi cần parse
 * @author DNThang - 17.03.2020
 */
let parseStringToDate = function(sDate) {
	if (typeof sDate == 'string') {
		let dte = mo(value);
		if (!dte.isValid()) {
			dte = dte.toDate();
			return dte;
		}
	}
};

let msFormat = {
	/**
	 * Định dạng Time (theo format string truyền vào)
	 * @param {DateTime/String} value Giá trị cần format
	 * @param {String} formatString Định dạng cần trả ra sau khi format. Nếu không truyền thì sẽ lấy theo session.TimeFormat
	 * @author DNThang - 17.03.2020
	 */
	formatTime(value, formatString) {
		if (value) {
			let ret = value,
				dte = value;
			if (typeof dte == 'string') {
				dte = parseStringToDate(dte);
			}

			if (dte instanceof Date) {
				//formatString = formatString ? formatString : session.TimeFormat;
				dte = mo(dte);
				if (dte.isValid()) {
					ret = dte.format(formatString);
				}
			}

			return ret;
		}
	},

	/**
	 * Format ngày tháng - trước mắt hỗ trợ dd/MM/yyyy
	 * Mặc định hỗ trợ định dạng YYYY-MM-DDTHH:mm:ss.SSSSZ (đây là format dữ liệu từ server)
	 * Bổ sung thêm hỗ trợ cho định dạng DD/MM/YYYY (do sử dụng từ )
	 * @param {Date/String} value
	 */
	formatDate(value) {
		if (!value) {
			return value;
		}

		let ret,
			dte = value;

		if (!(dte instanceof Date)) {
			if (value) {
				value = value.replace('Z', '');
			}
			dte = mo(value);
			if (!dte.isValid()) {
				let dateFormat = 'DD/MM/YYYY';
				dte = mo(value, dateFormat.toUpperCase());
				if (!dte.isValid()) {
					throw new Error(
						'DEV: value <' + value + '> format Date invalid.'
					);
				}
			}

			dte = new Date(dte.year(), dte.month(), dte.date());
			// dte = dte.toDate();
		}
		ret = dte.toLocaleDateString('vi', {
			day: '2-digit',
			month: '2-digit',
			year: 'numeric'
		});

		return ret;
	},

	//REM By DNThang - 17.03.2020: ai bổ sung hàm này vui lòng confirm
	// formatTimes(value) {
	// 	if (!value) {
	// 		return value;
	// 	}
	// 	value = new Date(value);
	// 	return value.toLocaleTimeString('vi');
	// },

	formatDateTimeFull(value) {
		if (!value) {
			return value;
		}

		let ret,
			format = 'DD/MM/YYYY HH:mm:ss',
			dte = value;

		if (!(dte instanceof Date)) {
			dte = mo(value);
			if (!dte.isValid()) {
				// let dateFormat = session.DateTimeFormat;
				// dte = mo(value, dateFormat.toUpperCase());
				// if (!dte.isValid()) {
				// 	throw new Error('DEV: value <' + value + '> format Date invalid.');
				// }
			}

			dte = dte.toDate();
		}

		let m = mo(dte);

		ret = m.format(format);

		return ret;
	},

	formatEnum(value, enumName) {
		if (typeof value == 'number' || value || typeof value == 'boolean') {
			let formatValue = Number(value);
			if (Number.isNaN(formatValue)) {
				formatValue = value;
			}
			if (enumName) {
				let enumObj = MSEnum[enumName];
				if (enumObj) {
					if (!Object.keys(enumObj)) {
						return '';
					}
					let key = Object.keys(enumObj).find(
						k => enumObj[k] === formatValue
					);
					if (key) {
						let text = i18nEnum[enumName][key];
						return text;
					} else {
						return formatValue;
					}
					// 	// return this.$t('i18nEnum.' + key + '');
				} else {
					return formatValue;
				}
			} else {
				return formatValue;
			}
		}
	},
	/**
	 * Thực hiện định dạng số tiền quy đổi theo hệ thống
	 */
	formatAmount(num, options) {
		let result = num;

		if (options && options.zeroToEmpty && num === 0) {
			return null;
		}

		if (num != undefined && num != null && session) {
			// let digits = session.AmountDecimalDigits,
			// 	buildDigits = 0;
			// msFormat.formatSeperator(options);
			// result = numeral(Number(num)).format('0,' + buildDigits.toFixed(digits));
			// result = msFormat.formatNegative(result);
		}

		return result;
	},

	/**
	 * Thực hiện định dạng số tiền nguyên tệ theo hệ thống
	 */
	formatAmountOC(num, options) {
		let result = num;

		if (options && options.zeroToEmpty && num === 0) {
			return null;
		}

		if (num != undefined && num != null && session) {
			// let digits = session.AmountOCDecimalDigits,
			// 	buildDigits = 0;
			// msFormat.formatSeperator(options);
			// result = numeral(Number(num)).format('0,' + buildDigits.toFixed(digits));
			// result = msFormat.formatNegative(result);
		}

		return result;
	},

	/**
	 * Thực hiện định dạng số tiền nguyên tệ theo hệ thống
	 */
	formatAllocation(num, options) {
		let result = num;

		if (options && options.zeroToEmpty && num === 0) {
			return null;
		}

		if (num != undefined && num != null && session) {
			// let digits = session.AllocationDecimalDigits,
			// 	buildDigits = 0;
			// msFormat.formatSeperator(options);
			// result = numeral(Number(num)).format('0,' + buildDigits.toFixed(digits));
			// result = msFormat.formatNegative(result);
		}

		return result;
	},

	/**
	 * Thực hiện định dạng số lượng theo hệ thống
	 */
	formatQuantity(num, options) {
		let result = num;

		if (options && options.zeroToEmpty && num === 0) {
			return null;
		}

		if (num != undefined && num != null && session) {
			// let digits = session.QuantityDecimalDigits,
			// 	buildDigits = 0;
			// msFormat.formatSeperator(options);
			// result = numeral(Number(num)).format('0,' + buildDigits.toFixed(digits));
			// result = msFormat.formatNegative(result);
		}

		return result;
	},
	/**
	 * Thực hiện định dạng số lượng theo hệ thống
	 */
	formatExchangeRate(num, options) {
		let result = num;

		if (options && options.zeroToEmpty && num === 0) {
			return null;
		}

		if (num != undefined && num != null && session) {
			// let digits = session.ExchangRateDecimalDigits,
			// 	buildDigits = 0;
			// msFormat.formatSeperator(options);
			// result = numeral(Number(num)).format('0,' + buildDigits.toFixed(digits));
			// result = msFormat.formatNegative(result);
		}

		return result;
	},
	/**
	 * Thực hiện format định dạng đơn giá quy đổi
	 */
	formatUnitPrice(num, options) {
		let result = num;

		if (options && options.zeroToEmpty && num === 0) {
			return null;
		}

		if (num != undefined && num != null && session) {
			// let digits = session.UnitPriceDecimalDigits,
			// 	buildDigits = 0;
			// msFormat.formatSeperator(options);
			// result = numeral(Number(num)).format('0,' + buildDigits.toFixed(digits));
			// result = msFormat.formatNegative(result);
		}

		return result;
	},
	/**
	 * Thực hiện format định dạng đơn giá nguyên tệ
	 */
	formatUnitPriceOC(num, options) {
		let result = num;

		if (options && options.zeroToEmpty && num === 0) {
			return null;
		}

		if (num != undefined && num != null && session) {
			// let digits = session.UnitPriceOCDecimalDigits,
			// 	buildDigits = 0;
			// msFormat.formatSeperator(options);
			// result = numeral(Number(num)).format('0,' + buildDigits.toFixed(digits));
			// result = msFormat.formatNegative(result);
		}

		return result;
	},
	/**
	 * Thực hiện format định dạng số của hệ số/tỷ lệ
	 */
	formatCoefficient(num, options) {
		let result = num;

		if (options && options.zeroToEmpty && !num) {
			return null;
		}

		if (num != undefined && num != null && session) {
			// let digits = session.CoefficientDecimalDigits,
			// 	buildDigits = 0;
			// msFormat.formatSeperator(options);
			// result = numeral(Number(num)).format('0,' + buildDigits.toFixed(digits));
			// result = msFormat.formatNegative(result);
		}

		return result;
	},
	/**
	 * Thực hiện format kiểu số không có định dạng sau dấu chấm
	 */
	formatNumber(num, options) {
		let result = num;

		if (options && options.zeroToEmpty && num === 0) {
			return null;
		}

		if (num != undefined && num != null) {
			let digits = 0,
				buildDigits = 0;
			if (options && options.digits) {
				digits = options.digits;
			}
			msFormat.formatSeperator(options);
			result = numeral(Number(num)).format(
				'0,' + buildDigits.toFixed(digits)
			);
			result = msFormat.formatNegative(result);
		}

		return result;
	},
	/**
	 * format số âm theo cấu hình
	 */
	formatNegative(value) {
		if (value.startsWith('-')) {
			value = ['(', value.substr(1), ')'].join('');
			// switch (session.CurrencyNegativePattern) {
			// 	case 0:
			// 		value = ['(', value.substr(1), ')'].join('');
			// 		break;
			// 	case 2:
			// 		value = value.substr(1) + '-';
			// 		break;
			// }
		}

		return value;
	},
	/**
	 * Format định dạng số với kí tự ngăn cách trên tùy chọn theo báo cáo hoặc các form thường
	 * @param {Object} options : tùy chọn hệ thống
	 */
	formatSeperator(options) {
		// let seperator = {
		// 	decimalCharacter: session.GeneralDecimalSeparator,
		// 	digitGroupSeparator: session.GeneralGroupSeparator
		// };
		// if (options && options.isReport) {
		// 	seperator.decimalCharacter = session.GeneralDecimalSeparatorReport;
		// 	seperator.digitGroupSeparator = session.GeneralGroupSeparatorReport;
		// }
		// numeral.localeData().delimiters.decimal = seperator.decimalCharacter;
		// numeral.localeData().delimiters.thousands = seperator.digitGroupSeparator;
	},
	/**
	 * Join mảng thành chuỗi string theo dấu ;
	 */
	formatJoinString(value) {
		try {
			let arr = value;
			if (typeof value === 'string') {
				arr = JSON.parse(value);
			}
			if (Array.isArray(arr)) {
				return arr.join('; ');
			}
		} catch (error) {
			return '';
		}
	},
	formatGroup(value) {
		if (value) {
			return value.substring(1, value.length - 1);
		}
	},
	formatTaxPeriod(value) {
		if (value && value.startsWith('00/')) {
			if (value.startsWith('00/QT/')) {
				return value.substring(6, value.length);
			} else if (value.startsWith('00/CN/')) {
				return value.substring(6, value.length);
			} else {
				return value.substring(3, value.length);
			}
		}
		return value;
	},
	formatEnumStatus(value, options) {
		if (typeof value == 'number' || value || typeof value == 'boolean') {
			let enumName = options.enumName;
			let formatValue = Number(value);
			if (Number.isNaN(formatValue)) {
				formatValue = value;
			}
			if (enumName) {
				let enumObj = MSEnum[enumName];
				if (enumObj) {
					if (!Object.keys(enumObj)) {
						return '';
					}
					let key = Object.keys(enumObj).find(
						k => enumObj[k] === formatValue
					);
					if (key) {
						let text = i18nEnum[enumName][key];
						return text;
					} else {
						return formatValue;
					}
					// 	// return this.$t('i18nEnum.' + key + '');
				} else {
					return formatValue;
				}
			} else {
				return formatValue;
			}
		}
	},
	formatRomanize(num) {
		let lookup = {
				M: 1000,
				CM: 900,
				D: 500,
				CD: 400,
				C: 100,
				XC: 90,
				L: 50,
				XL: 40,
				X: 10,
				IX: 9,
				V: 5,
				IV: 4,
				I: 1
			},
			roman = '',
			i;
		for (i in lookup) {
			while (num >= lookup[i]) {
				roman += i;
				num -= lookup[i];
			}
		}
		return roman;
	},
	formatDozens(value) {
		if (value < 10) {
			value = '0' + value;
		}
		return value;
	}
};

Vue.filter('formatGroup', msFormat.formatGroup);
Vue.filter('formatTime', msFormat.formatTime);
Vue.filter('formatTimeFull', msFormat.formatTimeFull);
Vue.filter('formatDate', msFormat.formatDate);
// Vue.filter('formatTimes', msFormat.formatTimes)
Vue.filter('formatDateTimeFull', msFormat.formatDateTimeFull);
Vue.filter('formatEnum', msFormat.formatEnum);
Vue.filter('formatAmount', msFormat.formatAmount);
Vue.filter('formatAmountOC', msFormat.formatAmountOC);
Vue.filter('formatAllocation', msFormat.formatAllocation);
Vue.filter('formatQuantity', msFormat.formatQuantity);
Vue.filter('formatExchangeRate', msFormat.formatExchangeRate);
Vue.filter('formatUnitPrice', msFormat.formatUnitPrice);
Vue.filter('formatUnitPriceOC', msFormat.formatUnitPriceOC);
Vue.filter('formatCoefficient', msFormat.formatCoefficient);
Vue.filter('formatJoinString', msFormat.formatJoinString);
Vue.filter('formatNumber', msFormat.formatNumber);
Vue.filter('formatTaxPeriod', msFormat.formatTaxPeriod);
Vue.filter('formatEnumStatus', msFormat.formatEnumStatus);
Vue.filter('formatRomanize', msFormat.formatRomanize);
Vue.filter('formatDozens', msFormat.formatDozens);

/**
 * Xử lý format cho các kiểu số
 * CreatedBy PDKIEN 21/12/2019
 *
 */
Vue.filter('formatData', function(value, options = {}) {
	let result;
	let enumName = options.enumName;
	if (options.enumName && typeof options.enumName == 'function') {
		enumName = options.enumName(options.dataRow);
	}
	if (enumName && value != null) {
		let valueData = Number(value) || value;
		if (valueData || valueData == 0) {
			result = msFormat.formatEnum(valueData, enumName);
		} else {
			result = value;
		}
		return result;
	} else {
		switch (options.formatType) {
			case MSEnum.FormatType.ExchangeRate:
				result = msFormat.formatExchangeRate(value, options);
				break;
			case MSEnum.FormatType.GroupItem:
				result = msFormat.formatGroup(value);
				break;
			case MSEnum.FormatType.DateTime:
				result = msFormat.formatDateTimeFull(value);
				break;
			case MSEnum.FormatType.Time:
				result = msFormat.formatTime(value, options.formatString);
				break;
				break;
			case MSEnum.FormatType.Rate:
				result = msFormat.formatCoefficient(value, options);
				break;
			case MSEnum.FormatType.Join:
				result = msFormat.formatJoinString(value);
				break;
			case MSEnum.FormatType.UnitPrice:
				result = msFormat.formatUnitPrice(value, options);
				break;
			case MSEnum.FormatType.Amount:
				result = msFormat.formatAmount(value, options);
				break;
			case MSEnum.FormatType.UnitPriceOC:
				result = msFormat.formatUnitPriceOC(value, options);
				break;
			case MSEnum.FormatType.AmountOC:
				result = msFormat.formatAmountOC(value, options);
				break;
			case MSEnum.FormatType.Allocation:
				result = msFormat.formatAllocation(value);
				break;
			case MSEnum.FormatType.Quantity:
				result = msFormat.formatQuantity(value, options);
				break;
			case MSEnum.FormatType.Number:
				result = msFormat.formatNumber(value, options);
				break;
			case MSEnum.FormatType.Date:
				result = msFormat.formatDate(value);
				break;
			case MSEnum.FormatType.TaxPeriod:
				result = msFormat.formatTaxPeriod(value);
				break;
			default:
				result = value;
				break;
		}
	}
	return result;
});

export default numeral;
export { msFormat };

//Chưa dùng đến
// Vue.filter('capitalize', function (value) {
//
// 	if (!value) return ''
// 	value = value.toString()
// 	let arr = value.split(" ")
// 	let capitalized_array = []
// 	arr.forEach((word) => {
// 		let capitalized = word.charAt(0).toUpperCase() + word.slice(1)
// 		capitalized_array.push(capitalized)
// 	})
// 	return capitalized_array.join(" ");
// })
// Vue.filter('truncate', function(value, limit) {
// 	return value.substring(0, limit)
// })
// Vue.filter('tailing', function(value, tail) {
// 	return value + tail;
// })
